import {Component, OnInit} from '@angular/core';
import {AuthService} from './core/services';
import { Meta } from '@angular/platform-browser';
import {environment} from '../environments/environment';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'sahbak-employer-dashboard';
  constructor(private authService: AuthService, private metaService: Meta) {}

  ngOnInit() {
    if (!environment.production) {
      this.metaService.addTag({name: 'robots', content: 'noindex,nofollow'});
    }
    this.authService.populate();
  }
}
